import { useEffect, useState } from 'react';
import api from '@/shared/api/client';

// Les regions de reference, pour TOUS les ecrans qui en font saisir une.
//
// LE DEFAUT QUE CE HOOK FERME
//
// La region etait un champ de texte LIBRE sur l'ecran de creation d'un client et sur
// celui de modification. Personne ne controlait ce qui entrait, donc le desordre
// s'aggravait a chaque client cree. Mesure du 30/08/2026 en pre-production, sur huit
// fiches : quatre « Ile-de-France », trois « ILe de france », une « Auvergne-Rhone-Alpes ».
// Le filtre de la carte proposait donc deux entrees pour un seul territoire, et David
// le decrit ainsi : « on ne voit plus que l'Ile-de-France ».
//
// Le serveur refuse desormais une region hors liste (`refuser_region_inconnue`). Un
// champ libre devant un serveur qui refuse serait le pire des deux mondes : on laisse
// taper, puis on rejette. La liste deroulante rend le refus impossible a atteindre.
//
// LE REPLI N'EST PAS UN HABILLAGE
//
// Sans lui, une panne de l'appel viderait la liste et empecherait de renseigner la
// moindre region. Il porte les memes valeurs que `REGIONS_REFERENCE` cote serveur,
// dans le meme ordre — c'est la SEULE recopie de cette liste dans le produit, et elle
// est gardee par `test_le_repli_du_navigateur_porte_la_meme_liste_que_le_serveur`.
export const REGIONS_PAR_DEFAUT = [
  'Auvergne-Rhone-Alpes', 'Bourgogne-Franche-Comte', 'Bretagne', 'Centre-Val de Loire',
  'Corse', 'Grand Est', 'Guadeloupe', 'Guyane', 'Hauts-de-France', 'Ile-de-France',
  'La Reunion', 'Martinique', 'Mayotte', 'Normandie', 'Nouvelle-Aquitaine', 'Occitanie',
  'Pays de la Loire', "Provence-Alpes-Cote d'Azur",
];

export default function useRegions() {
  const [regions, setRegions] = useState(REGIONS_PAR_DEFAUT);

  useEffect(() => {
    let vivant = true;
    api.get('/admin/menus')
      .then(({ data }) => {
        if (vivant && Array.isArray(data?.regions) && data.regions.length) {
          setRegions(data.regions);
        }
      })
      .catch(() => { /* le repli reste en place : mieux vaut dix-huit regions que zero */ });
    return () => { vivant = false; };
  }, []);

  return regions;
}
